import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnGroup } from 'react-table';

import i18next from 'i18next';

import { routes } from 'data/routes';

import * as S from './List.styles';

export const useColumns = () => {
  const { t } = useTranslation();

  return useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Budget',
        columns: [
          {
            Header: '#',
            accessor: 'num',
          },
          {
            Header: t('common.name')!,
            accessor: 'name',
          },
          {
            Header: t('common.date')!,
            accessor: 'date',
          },
          {
            Header: t('common.actions')!,
            accessor: 'id',
            Cell: ({ row }) => (
              <S.BtnWrapper>
                <S.ActionBtn
                  iconLeft="FiEdit"
                  motive="actionSecondary"
                  asLink
                  to={routes.budgetDetails(row.original.genderCode, row.original.num)}
                  state={{ name: row.original.name, type: row.original.type }}
                />
              </S.BtnWrapper>
            ),
          },
        ],
      },
    ],
    [i18next.language]
  );
};
